import React, { useEffect, useState } from "react";
import Loader from "components/atoms/Loader";
import EventModalModeration from "componentsV2/molecules/Modals/EventModals/EventModalModeration";
import EventModalShow from "componentsV2/molecules/Modals/EventModals/EventModalShow";
import Toolbar from "componentsV2/pages/EventsCalendarPage/CalendarComponents/Toolbar";
import { useEventsContext } from "hooks/useContexts";
import useRouterStuff from "hooks/useRouterStuff";
import { getTimezonesData } from "shared/utils";

import ListEventsByMonthYear from "./ListEventsByMonthYear";
import styles from "./style.module.scss";

const ACCEPTED = "ACCEPTED";

export default function EventPartnerList({
  events,
  moderation = false,
  listEvents = false,
  editEvents = false,
  viewOnly = false,
  cloudServices,
  eventTypes,
  regions,
  products,
  partnerId,
  providerId,
  userPermissions,
  isSiteAdminPage = false,
  partnerName = "",
  partnerSlug = "",
  currentSubTabCalendar,
  usersTimezoneData,
  doNotShowViewAllPartner = false,
}) {
  const {
    selectedEvent,
    setSelectedEvent,
    allTimezones,
    view,
    setView,
    currentDate,
    setCurrentDate,
    selectedTab,
    setSelectedTab,
    usersTimezoneLocation,
  } = useEventsContext();

  const [isOpen, setIsOpen] = useState(selectedEvent !== null);
  const [isLoading, setIsLoading] = useState(false);
  const [rangeDate, setRangeDate] = useState<{
    startDate: string | null;
    endDate: string | null;
  }>({
    startDate: null,
    endDate: null,
  });

  const { searchParamsObj, queryParams } = useRouterStuff();

  const yearOfEvents = moderation
    ? events
        .map((e) => {
          return new Date(e.startDate).getFullYear();
        })
        .filter((item, pos, arr) => arr.indexOf(item) == pos)
        .sort((a, b) => b - a)
    : [];

  console.debug(yearOfEvents);

  const timezonesData = getTimezonesData(allTimezones, usersTimezoneLocation);

  const selectArrowStyle = {
    height: "19px",
    width: "243px",
  };

  const getCurrentDimension = () => {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  };
  const [screenSize, setScreenSize] = useState(getCurrentDimension());

  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension());
    };
    window.addEventListener("resize", updateDimension);

    return () => {
      window.removeEventListener("resize", updateDimension);
    };
  }, [screenSize]);

  useEffect(() => {
    const { eventId } = searchParamsObj;
    if (eventId) {
      setSelectedEvent(events.find((el) => el.id === Number(eventId)));
      queryParams({
        set: {
          eventId: eventId,
        },
      });
      setIsOpen(true);
    }
  }, [searchParamsObj.eventId]);

  useEffect(() => {
    if (!isOpen) {
      setSelectedEvent(null);
      queryParams({ del: ["eventId"] });
    }
  }, [isOpen]);
  return isLoading ? (
    <Loader />
  ) : (
    <>
      <div
        className={styles.wrapper}
        style={
          screenSize.width < 500 ? { width: "120%", marginLeft: "-30px" } : {}
        }
      >
        <div className={styles.header}>
          {!moderation && !listEvents ? (
            <span>Upcoming Partner Events</span>
          ) : null}
        </div>
        <div
          className={
            moderation || listEvents
              ? styles.months_wrapper_mod
              : styles.months_wrapper
          }
        >
          {!moderation ? (
            <Toolbar
              currentDate={currentDate}
              customStyles={selectArrowStyle}
              seeYearly
              selectedTab={selectedTab}
              setCurrentDate={setCurrentDate}
              setRangeDate={setRangeDate}
              setSelectedTab={setSelectedTab}
              setView={setView}
              view={view}
            />
          ) : null}

          {moderation && events?.length > 0 ? (
            yearOfEvents.map((year, index) => (
              <ListEventsByMonthYear
                currentSubTabCalendar={currentSubTabCalendar}
                editEvents={editEvents}
                events={events}
                isSiteAdminPage={isSiteAdminPage}
                key={"list-events-by-month-year" + index.toString()}
                listEvents={listEvents}
                moderation={moderation}
                rangeDate={rangeDate}
                screenSize={screenSize}
                setIsLoading={setIsLoading}
                setIsOpen={setIsOpen}
                setSelectedEvent={setSelectedEvent}
                timezonesData={timezonesData}
                usersTimezoneData={usersTimezoneData}
                usersTimezoneLocation={usersTimezoneLocation}
                year={year}
                yearOfEvents={yearOfEvents}
              />
            ))
          ) : (
            <ListEventsByMonthYear
              currentSubTabCalendar={currentSubTabCalendar}
              editEvents={editEvents}
              events={events}
              isSiteAdminPage={isSiteAdminPage}
              listEvents={listEvents}
              moderation={moderation}
              rangeDate={rangeDate}
              screenSize={screenSize}
              setIsLoading={setIsLoading}
              setIsOpen={setIsOpen}
              setSelectedEvent={setSelectedEvent}
              timezonesData={timezonesData}
              usersTimezoneData={usersTimezoneData}
              usersTimezoneLocation={usersTimezoneLocation}
              year={
                rangeDate?.startDate !== null
                  ? rangeDate?.startDate?.split("T")[0].split("-")[0]
                  : new Date().getFullYear().toString()
              }
              yearOfEvents={yearOfEvents}
            />
          )}
          {!moderation && !listEvents ? <div className={styles.line} /> : null}
        </div>
      </div>
      {isOpen && selectedEvent ? (
        viewOnly &&
        !(isSiteAdminPage && selectedEvent.contentStatus !== ACCEPTED) ? (
          <EventModalShow
            changeSetOpen={setIsOpen}
            doNotShowViewAllPartner={doNotShowViewAllPartner}
            isOpen={isOpen}
          />
        ) : (
          <EventModalModeration
            changeSetOpen={setIsOpen}
            cloudServices={cloudServices}
            editEvents={editEvents}
            eventTypes={eventTypes}
            initialEventState={undefined}
            isModeration={
              moderation ||
              (isSiteAdminPage && selectedEvent.contentStatus !== ACCEPTED)
            }
            isOpen={isOpen}
            isSiteAdminPage={isSiteAdminPage}
            newEventsCreate={undefined}
            partnerId={partnerId}
            partnerName={partnerName}
            partnerSlug={partnerSlug}
            products={products}
            providerId={providerId}
            regions={regions}
            userPermissions={userPermissions}
          />
        )
      ) : null}
    </>
  );
}
